import Ad from './Ad.vue'
import module from './store'
import { createTargetDefinitionWatcher } from './store/watchers'
import { createStoreConnector } from '@/store'

const unwatchers = []

export default createStoreConnector('ad', module('ad'), {
  onRegistered: store => {
    unwatchers.push(createTargetDefinitionWatcher(store))
  },
  onUnregistered: () => {
    unwatchers.forEach(unwatcher => unwatcher.call())
  }
})(Ad)



// WEBPACK FOOTER //
// ./src/app/views/workbench/AD/index.js